<template>
    <div style="height: auto;">
        <div class="card p-3">
            <h4 class="p-2">Indicador de usabilidad de SIGeM</h4>
            <vs-row class="mt-4">
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="cicloEscolar" class="labelInput">
                            Ciclo Escolar
                        </label>
                        <vs-select filter :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length">
                            <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                Requerido
                            </template>
                            <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col> 
                <vs-col sm="12" lg="4">
                    <div class="d-flex " style="justify-content: space-between;">
                        <label for="institucion" class="labelInput">
                            Institución
                        </label>
                        <div class="d-flex" v-if="instituciones[0]">
                            <div> 
                                <vs-tooltip>
                                    <i class="fas fa-check-square" style="cursor:pointer" @click="selectAll(instituciones, 'instituciones')"></i>
                                    <template #tooltip>
                                        Seleccionar todo
                                    </template>
                                </vs-tooltip>
                            </div>
                            <div class="labelInput">
                                <vs-tooltip>
                                    <i class="far fa-times-circle" style="cursor:pointer" @click="deseleccionarAll('instituciones')"></i>
                                    <template #tooltip>
                                        Deseleccionar todo
                                    </template>
                                </vs-tooltip>
                            </div>
                            
                        </div>
                    </div>
                    <vs-select :loading="loadingInstitucion" filter multiple collapse-chips class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </vs-col>
                <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                    <vs-button
                        @click="getUsabilidadSigem()"
                    >
                        <i class="fas fa-search mr-2"></i>Buscar
                    </vs-button>
                </vs-col>
            </vs-row>
        </div>
        <card-graph :graph="graph" :tablaIndividual="tablaIndividual"></card-graph>
    </div>
</template>

<script>
import LineChart from '../../../charts/LineChart'
import indicadores from '../../../../api/requests/indicadores'
import CardGraph from './card-graph-usabilidad.vue'
export default {
    components: {
        LineChart
    },
    props: [
        'data',
    ],
    data() { 
        return {
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            loadingInstitucion: false,
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            loadingCiclo: false,
            errorFields: [],
            search: '',
            datacollection: null,
            graph: {
                labels: [],
                porcentaje: []
            },
            tablaIndividual: []
        }
    },
    created(){
        this.getCicloEscolar()
    },
    components:{
        CardGraph
    },
    methods: {
        async getCicloEscolar() {
            this.loadingCiclo = true
            try {
                const { data: response } = await indicadores.getCiclosEscolaresUsabilidad()
                this.ciclosEscolares = this.getEliminarNameKey(response)
                this.cicloId = (new Date()).getTime()
                this.loadingCiclo = false
            }
            catch(error){
                this.loadingCiclo = false
                console.error(error)
            }
        },
        async getInstitucionesUsabilidad(){
            this.institucion = ''
            this.instituciones = []
            this.loadingInstitucion = true
            try {
                const response = await indicadores.getInstitucionesUsabilidad(this.cicloEscolar)
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstitucion = false
            }
            catch(error){
                this.loadingInstitucion = false
                console.error(error)
            }
        },
        getEliminarNameKey(info){
            const datos = Object.values(info)
            return datos
        },        
        selectAll(seleccion, tipo){
            let arr = []
            seleccion.forEach(i => {
              arr.push(i.id)
            })
            if(tipo == 'instituciones'){
                this.institucion = arr
            }
        },
        deseleccionarAll(tipo){
            if(tipo == 'instituciones'){
                this.institucion = ''
            }
        },
        async getUsabilidadSigem(){
            const loading = this.$vs.loading()
            this.graph =  {
                labels: [],
                porcentaje: []
            }
            const vm = this
            try{
                const params = {
                    ciclo_escolar_id: this.cicloEscolar,
                }
                
                if(this.institucion[0] == ''){
                    const eliminar = this.institucion.shift()
                    params.institucion_ids = this.institucion
                }else{
                    params.institucion_ids = this.institucion
                }
                const {data: response} = await indicadores.getUsabilidadSigem(params)
                this.tablaIndividual = response
                loading.close()
                response.forEach(x => {
                    vm.graph.labels.push(x.institucion)
                    vm.graph.porcentaje.push(x.porcentaje_usabilidad)
                    // x.usabilidad.forEach(u => {
                    //     obj.labels.push(u.titulo)
                    //     if(u.status){
                    //         obj.ponderacion.push(u.ponderacion)
                    //     }else{
                    //         obj.ponderacion.push('0')
                    //     }
                    // })
                })
            
            }catch(error){
                console.error(error)
                loading.close()
            }
        },
        fillData({institucion, labels, ponderacion}) {
                return {
                    labels:labels,
                    datasets: [{
                        label: 'Ponderación',
                        backgroundColor: "rgba(36,113,163,0.2)",
                        borderColor: "rgba(36,113,163,0.2)",
                        borderWidth: 2,
                        hoverBackgroundColor: "rgba(36,113,163,0.4)",
                        hoverBorderColor: "rgba(36,113,163,0.4)",
                        data: ponderacion,
                    }]
                }
        },
        optionsGraph(){
            return {
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        display: true,
                        gridLines: {
                            display: true,
                            color: "rgba(255,99,132,0.2)"
                        },
                        ticks: {
                            suggestedMin: 0,
                            beginAtZero: true,
                        }
                    }],
                    yAxes: {
                        display: true,
                        gridLines: {
                            display: false,
                            color: "rgba(255,99,132,0.2)"
                        }
                    }
                },
                maintainAspectRatio: false,
            }
        }
    },
    watch:{
        cicloEscolar(){
            this.getInstitucionesUsabilidad()
        }
    }
}
</script>
